var pre = '/dashboard/';
export default {
  path: '/dashboard',
  title: 'Dashboard',
  header: 'home',
  icon: 'md-speedometer',
  children: [{
    path: "".concat(pre, "console"),
    title: '我的首页'
  }]
};